import { render, staticRenderFns } from "./SocitiesList.vue?vue&type=template&id=6988081f&scoped=true"
import script from "./SocitiesList.vue?vue&type=script&lang=js"
export * from "./SocitiesList.vue?vue&type=script&lang=js"
import style0 from "./SocitiesList.vue?vue&type=style&index=0&id=6988081f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988081f",
  null
  
)

export default component.exports